import React, { createContext, useContext } from "react";

import { getStrategyDashboardConfig } from "./strategyDashboardConfig";

const StrategyDashboardContext = createContext(null);

export function StrategyDashboardProvider({ strategyId, children }) {
  const dashboard = getStrategyDashboardConfig(strategyId);

  return (
    <StrategyDashboardContext.Provider value={dashboard}>
      {children}
    </StrategyDashboardContext.Provider>
  );
}

export function useStrategyDashboardConfig() {
  const dashboard = useContext(StrategyDashboardContext);

  if (!dashboard) {
    throw new Error(
      "useStrategyDashboardConfig must be used within StrategyDashboardProvider"
    );
  }

  return dashboard;
}
